import { GET_REPLY_RECOMMENDATIONS_WITH_REASON_QUERY } from '../../../../__generated__/chirp/com/hubspot/cv/replies/rpc/ReplyRecommendationsFrontendService.dfc.new';
export const updateReplyRecommendationCache = (client, message, threadId) => {
  const threadIdNumber = parseInt(threadId, 10);
  if (!client || !message || !threadId || isNaN(threadIdNumber)) {
    return;
  }
  try {
    client.writeQuery({
      query: GET_REPLY_RECOMMENDATIONS_WITH_REASON_QUERY,
      variables: {
        threadId: threadIdNumber
      },
      data: {
        result: message
      }
    });
  } catch (error) {
    // If query doesn't exist in cache yet, we can safely ignore
    // The next time the component queries, it will get fresh data
  }
};